<div *ngIf="selectedNode">

    <div *ngIf="!isProdAttachment()">
        <span *ngIf="!showDetailedAddNodes() && !hasChildren()"
            [ngStyle]="{'color': !isValid(selectedNode)  ? 'red' : 'black'}">There are no {{!selectedNode.labelNodeName.toLowerCase().includes('messages') ? 'messages': ''}} {{selectedNode.labelNodeName.toLowerCase()}} referenced within this item</span>
    </div>

    <div *ngIf="isProdAttachment()">
        <span *ngIf="!showDetailedAddNodes() && !hasChildren()"
            [ngStyle]="{'color': !isValid(selectedNode)  ? 'red' : 'black'}">No Product Attachment(s) can be viewed for this item.</span>
    </div>

    <div *ngIf="showDetailedAddNodes()">
        <app-list-detailed-add-nodes [selectedNode]="selectedNode"
            (buttonAction)="onButtonAction($event)"></app-list-detailed-add-nodes>
    </div>

    <div class="scroll-container" style="overflow-y: auto;"
        [ngStyle]="{'height': showDetailedAddNodes()? 'calc(100vh - 300px)':  !hasChildren()?'calc(100vh - 260px)':'calc(100vh - 235px)'}">
        <div *ngIf="hasChildren()">
            <table class="table table-striped table-hover table-sm table-max-width">
                <thead style="position: sticky;top: 0;">
                    <tr>
                        <th *ngIf="!isListView()" 
                            style="cursor: pointer;white-space: nowrap;position: sticky;top: 0;overflow: hidden; text-overflow: ellipsis;"                 
                    [columnIndex]="column"
                storageKey="'itemsTable:'{{column}}"
                appResizableColumn><a (click)="sortByNum()">Num {{sortIcon(-1)}}</a>
                        </th>
                        <th *ngIf="isListView() && !isListViewNode()" 
                            style="cursor: pointer;white-space: nowrap;position: sticky;top: 0;overflow: hidden; text-overflow: ellipsis;"                 
                    [columnIndex]="column"
                storageKey="'itemsTable:'{{column}}"
                appResizableColumn><a (click)="sortByNum()">{{ column }} {{sortIcon(-1)}}</a></th>
                        <th *ngFor="let column of selectedNode.getHeaders(); let i = index"
                            style="cursor: pointer;white-space: nowrap;position: sticky;top: 0;overflow: hidden; text-overflow: ellipsis;"                 
                    [columnIndex]="i"
                storageKey="'itemsTable:'{{column}}"
                appResizableColumn><a
                                (click)="sortBy(i)">{{ column }}
                                {{sortIcon(i)}}</a></th>
                        <th style="position: sticky;top: 0;"></th>
                    </tr>
                </thead>
                <tbody *ngIf="isListViewNode()">
                    <tr style='cursor:pointer' *ngFor="let item of selectedNode.children">
                        <td *ngIf="!isResultList()" style="white-space: nowrap;"
                            [ngStyle]="{'color': !isValid(item)  ? 'red' : 'black'}"><input type="checkbox"
                                *ngIf="showCheckbox()" [checked]="item.checked"
                                (change)="onCheckedChange(item)" />&nbsp;<span
                                (click)="onSelectedNodeChange(item);$event.preventDefault();">{{item.num}}</span></td>
                        <td style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;"
                            *ngFor="let value of item.getListItem(); let i = index"
                            (click)="onSelectedNodeChange(item);$event.preventDefault();"
                            [ngStyle]="{'color': !isValid(item)  ? 'red' : 'black'}" [attr.title]="showToolTip(item)">
                            {{item.getListItem()[i]}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>